import React, { Fragment } from "react";
import WebDesignPackagesData from "../../../Data/PackagesData/WebDesignPackagesData";
import PackagesTab from "../../PackagesSections/PackagesTab";

const ServicePackages = (props) => {
  const { servicePackagesProps } = props;
  return (
    <section id="tabs" className="pt-3 pt-md-5 project-tab text-dark pb-4">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center p">
            <p className="font-15 let-space-2">
              {servicePackagesProps?.spCaption}
            </p>
            <h2 className="font-50 font-w800 text-dark pb-4">
              {servicePackagesProps?.spTitle.map((title, i) => (
                <Fragment key={i}>
                  {title.spTitle}
                  <br />
                </Fragment>
              ))}
            </h2>
            <p className="font-w300 text-grey">
              {servicePackagesProps?.spShortDescription}
            </p>
          </div>
        </div>
        <PackagesTab data={servicePackagesProps.spData} carousel={true} />
        <div
          className="row service-pricing-bot"
          style={{
            background:
              'url("images/services/pricing-bottom-img.png")no-repeat center bottom/auto',
          }}
        >
          <div className="col-12">
            <p className="font-20 font-w300 text-grey text-center">
              {servicePackagesProps?.spDescription}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicePackages;
